import { render, staticRenderFns } from "./GenericReviewList.vue?vue&type=template&id=632c446e&scoped=true"
import script from "./GenericReviewList.vue?vue&type=script&lang=js"
export * from "./GenericReviewList.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/generic-list.css?vue&type=style&index=0&id=632c446e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c446e",
  null
  
)

export default component.exports